import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Package, Home, Box, QrCode, User, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-title">
        <Package size={28} style={{ display: 'inline', marginRight: '10px' }} />
        Invy
      </div>
      <ul className="navbar-nav">
        <li>
          <Link to="/" className="navbar-link">
            <Home size={20} style={{ display: 'inline', marginRight: '5px' }} />
            Locations
          </Link>
        </li>
        <li>
          <Link to="/items" className="navbar-link">
            <Box size={20} style={{ display: 'inline', marginRight: '5px' }} />
            Items
          </Link>
        </li>
        <li>
          <Link to="/scan" className="navbar-link">
            <QrCode size={20} style={{ display: 'inline', marginRight: '5px' }} />
            Scan
          </Link>
        </li>
        <li className="navbar-user-menu">
          <button 
            className="navbar-user-button"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <User size={20} style={{ display: 'inline', marginRight: '5px' }} />
            {user?.name || user?.email}
          </button>
          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-info">
                <p className="user-name">{user?.name}</p>
                <p className="user-email">{user?.email}</p>
                <p className="user-provider">Signed in with {user?.provider}</p>
              </div>
              <button onClick={logout} className="logout-button">
                <LogOut size={18} style={{ display: 'inline', marginRight: '8px' }} />
                Sign out
              </button>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
